import React, { Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessVendorSourceLocationDTO from "../../../models/DTO/IOnProcessVendorSourceLocationDTO";
import IProcessVendorSourceLocationDTO from "../../../models/DTO/IProcessVendorSourceLocationDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source from "../../../models/IVendor_Source";
import IVendor_Source_Location from "../../../models/IVendor_Source_Location";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwButton from "../../shared/OwButton/OwButton";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import VendorSourceLocationSidebar from "../VendorSourceLocationSidebar/VendorSourceLocationSidebar";
import { Socket } from "socket.io-client";
import {ConfirmDeleteOverlayFn} from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import {OwDeleteEditActions} from "../../shared/OwDeleteEditActions/OwDeleteEditActions";

type Props = {
    vendorSource: IVendor_Source;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    refreshVendorSources: () => void;
};

type State = {
    columns: IOwTableCols[];
    sourceElem: string | null;
    confirmDeleteRow?: IVendor_Source_Location;
};

export default class VendorSourceLocationDetailView extends Component<Props, State> {
    overlayRef: any = null;

    constructor(props: any) {
        super(props);

        this.state = {
            columns: [
                {
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderActions,
                    renderFnEmitsRow: true,
                },
                {
                    title: "name",
                    valueProp: "name",
                },
                {
                    title: "address",
                    valueProp: "",
                    renderFn: this.renderAddress,
                    renderFnEmitsRow: true,
                },
            ],
            sourceElem: null,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessVendorSourceLocation, this.onProcessVendorSourceLocation);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnProcessVendorSourceLocation, this.onProcessVendorSourceLocation);
    }

    addLocation = () => {
        this.openSidebar();
    };

    renderAddress = (row: IVendor_Source_Location) => {
        if (row.Address) {
            return (
                <div className={"d-flex"}>
                    {this.props.supplierModel.has_google_maps ? (
                        <OwGoogleStaticMap address={row.Address} size={"120x120"} className={"me-2"} />
                    ) : null}
                    <AddressDisplay address={row.Address} />
                </div>
            );
        } else {
            return null;
        }
    };

    renderActions = (row: IVendor_Source_Location, index: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        this.toggleDelete(row, index);
                    }}
                    onEditClickFn={() => {
                        this.openSidebar(row);
                    }}
                />
            </div>
        );
    };

    cancelFn = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
        this.props.refreshVendorSources();
    };

    openSidebar = (location?: IVendor_Source_Location) => {
        const component = (
            <VendorSourceLocationSidebar
                cancelFn={this.cancelFn}
                userModel={this.props.userModel}
                socket={this.props.socket}
                supplierModel={this.props.supplierModel}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
                vendorSourceLocation={location}
                vendorSource={this.props.vendorSource}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    toggleDelete = (row: IVendor_Source_Location, index: number) => {
        const sourceElem = `row-${this.props.vendorSource.id}-${index}`;
        console.log('sourceElem: ', sourceElem);

        this.setState({
            sourceElem,
            confirmDeleteRow: row,
        });
    };

    cancelDelete = () => {
        this.overlayRef = null;

        this.setState({
            sourceElem: null,
            confirmDeleteRow: undefined,
        });
    };

    commitDelete = () => {
        if (this.state.confirmDeleteRow) {
            const payload: IProcessVendorSourceLocationDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorSourceGuid: this.props.vendorSource.guid,
                deleteFlag: true,
                location: this.state.confirmDeleteRow,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourceLocation, payload);

            this.setState({
                sourceElem: null,
            });
        }
    };

    onProcessVendorSourceLocation = (data: IOnProcessVendorSourceLocationDTO) => {
        if (this.state.confirmDeleteRow) {
            this.setState(
                {
                    confirmDeleteRow: undefined,
                    sourceElem: null,
                },
                () => {
                    this.props.refreshVendorSources();
                }
            );
        }
    };

    render() {
        return (
            <div className={"VendorSourceLocationDetailView position-relative"}>
                <div className="row">
                    <div className={"col-12 d-flex"}>
                        <OwTitle title={"locations"} tag={"h5"} />
                        <div className={"ms-2"}>
                            <OwButton title={"add"} fn={this.addLocation} />
                        </div>
                    </div>
                </div>

                <div className="row position-relative">
                    <div className="col-12">
                        <ConfirmDeleteOverlayFn
                            targetElem={this.state.sourceElem}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            nestedParentElem={`vendor-source-location-table-${this.props.vendorSource.guid}`}
                            skipMainView={true}
                            leftAdjustment={-12}
                        />

                        <OwTable
                            id={`vendor-source-location-table-${this.props.vendorSource.guid}`}
                            columns={this.state.columns}
                            dataSet={this.props.vendorSource.Vendor_Source_Locations || []}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={false}
                            initialData={false}
                            parentRowIndex={this.props.vendorSource.id}
                            isDetailViewTable={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
